import React from 'react';
import { MainLayout } from '@components';
import XRaysComponents from './XRay';

export default function XRaysPage(props) {
  return <MainLayout footer="main" children={<XRaysComponents {...props} />} />;
}
